import { Property } from './interfaces';

export const numFEVPagoModerador: Property = {
    title: "Número de FEV Pago Moderador",
    type: "string",
};
